import React from 'react'

import type { WaveLinkHeaderContentBlock } from '@library/api-menu-experience'
import { WaveLinkHeader } from '@library/menu-page'

import { useMenuExperienceCategoryNavigation } from '../menuExperienceNavigationContext'

type WaveLinkHeaderContentBlockWrapperProps = {
  contentBlock: WaveLinkHeaderContentBlock
}

export const WaveLinkHeaderContentBlockWrapper = ({
  contentBlock,
}: WaveLinkHeaderContentBlockWrapperProps) => {
  const { selectCategory } = useMenuExperienceCategoryNavigation()

  const onClick = () => {
    if (!contentBlock.categoryId || !contentBlock.categorySlug) {
      return
    }

    selectCategory(
      {
        id: contentBlock.categoryId,
        slug: contentBlock.categorySlug,
      },
      'menu_banner',
    )
  }

  return <WaveLinkHeader contentBlock={contentBlock} onClick={onClick} />
}
